"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCloudFunctionApiClient = void 0;
/**
 * Creates a client for running cloud functions defined in `types/CloudFunctionApi.ts`
 * This uses a proxy for convenience, but you could define the functions manually with `httpsCallableFn` to support old browsers.
 */
function getCloudFunctionApiClient(functions) {
    const fnCache = new Map();
    return new Proxy({}, {
        get(_, key) {
            if (!fnCache.has(key)) {
                const fn = httpsCallableFn(key);
                fnCache.set(key, fn);
                return fn;
            }
            return fnCache.get(key);
        },
    });
    function httpsCallableFn(key) {
        const callable = functions.httpsCallable(key);
        const fn = async (options) => {
            const { data } = await callable(options || {});
            return data;
        };
        return fn;
    }
}
exports.getCloudFunctionApiClient = getCloudFunctionApiClient;
//# sourceMappingURL=getCloudFunctionsClient.js.map